module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1 calibre1",
    attrs: {
      "id": "dixie1"
    }
  }, [_c('p', {
    staticClass: "normal-241-0-override"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("DIXIE’S LAST STAND")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-241-0-override"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-241-0-override"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("Was it Murder or Self-Defense?")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-241-0-override"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-241-0-override"
  }, [_c('span', {
    staticClass: "no-style-override2"
  }, [_vm._v("An Original True-Crime Feature")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-241-0-override"
  }, [_c('span', {
    staticClass: "no-style-override2"
  }, [_vm._v("by John Ferak, WildBlue Press")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_0"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65bc8330","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Title.vue
// module id = 60
// module chunks = 0